import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

import { InputWrapper as InputWrapperBase, TextInputStyled } from '../../../Book/steps/styles';

type Props = {
  value: string;
  error: boolean | null;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  className?: string;
  hasEmployer?: boolean;
};

const PromoCode = (props: Props) => {
  const { value, error, onChange, onSubmit, className, hasEmployer = false } = props;
  const label = hasEmployer ? 'ACCESS CODE' : 'PROMO CODE';
  const placeholder = hasEmployer ? 'Required' : 'Optional';
  return (
    <PromoCodeWrapper className={className}>
      <InputWrapper>
        <TextInputStyled
          label={label}
          placeholder={placeholder}
          value={value}
          error={error || undefined}
          onChange={onChange}
        />
      </InputWrapper>
      <PromoLink onClick={onSubmit}>APPLY</PromoLink>
    </PromoCodeWrapper>
  );
};

const PromoCodeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const PromoLink = styled.a`
  ${props => props.theme.fonts.FoundersGrotesk};
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
  padding-bottom: 6px;
`;

const InputWrapper = styled(InputWrapperBase)`
  margin: 0;
  margin-right: 5px;
  width: 175px;
`;

export default PromoCode;
